import React from "react";
import { Text, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import ImageComponent from "../ImageComponent";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { useLiveStream } from "../../context/LiveStreamContext";
import { CommonButton } from "../../common/CommonButton";
import Avatar from "../choose-avatar-components/Avatar";

const PlayersView = ({ isStreaming = false, resultWaiting = false }) => {
  console.log("isStreaming", isStreaming);

  const { audienceData } = useLiveStream();
  const deviceSize = useDeviceSize();

  const { eventDetails, participantDetails } = audienceData;

  const organizer =
    participantDetails.find(
      (participant) => participant.userID === eventDetails.organiserId
    ) || {};

  const challenger =
    participantDetails.find(
      (participant) => participant.userID !== eventDetails.organiserId
    ) || {};

  const isWinnerSet =
    Boolean(eventDetails?.resultStatus?.winner) &&
    eventDetails?.resultStatus?.dispute === false;

  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;

  return (
    <View
      style={{
        flexDirection: "column",
        gap: resultWaiting ? (isMobile ? 12 : 16) : isMobile ? 12 : 20,
      }}
    >
      {/* Result Waiting Message - Above player sections */}
      {resultWaiting && (
        <View
          style={{
            alignItems: "center",
            gap: 16,
            paddingHorizontal: isMobile ? 16 : 0,
          }}
        >
          {/* "Who is the winner?" Text */}
          <Text
            style={{
              color: "#00FF26",
              fontFamily: "Anybody_700Bold",
              fontSize: isMobile ? 20 : 32,
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            Who is the winner?
          </Text>

          {/* Red Message Box */}
          <LinearGradient
            colors={["rgba(127, 29, 29, 0.20)", "rgba(153, 27, 27, 0.20)"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
              width: isMobile ? "100%" : 539,
              padding: 16,
              flexDirection: "column",
              alignItems: "center",
              gap: 12,
              borderRadius: 8,
              borderWidth: 0.8,
              borderColor: "rgba(239, 68, 68, 0.30)",
            }}
          >
            <Text
              style={{
                color: "#DC2626",
                textAlign: "center",
                fontFamily: "Anybody_900Black",
                fontSize: isMobile ? 18 : 26,
                fontWeight: "900",
                lineHeight: isMobile ? 20.79 : 30.03,
              }}
            >
              Event has come to an end
            </Text>
            <Text
              style={{
                color: "#DC2626",
                textAlign: "center",
                fontFamily: "Anybody_500Medium",
                fontSize: isMobile ? 14 : 18,
                fontWeight: "500",
                lineHeight: isMobile ? 16.17 : 20.79,
              }}
            >
              We are waiting for the results.
            </Text>
          </LinearGradient>
        </View>
      )}

      {/* Player Sections Row */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingHorizontal: isMobile ? 0 : 16,
          paddingVertical: resultWaiting ? 0 : isMobile ? 0 : 20,
          gap: isMobile ? 8 : 16,
        }}
      >
        {/* Organizer Section */}
        <View
          style={{
            flex: 1,
            alignItems: "center",
            gap: isMobile ? 4 : resultWaiting ? 6 : 12,
            height: resultWaiting ? (isMobile ? 150 : 170) : undefined,
          }}
        >
          {/* Kaller Label */}
          <Text
            style={[
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? AppFontStyle.BOLD_ANYBODY_14
                : AppFontStyle.BOLD_ANYBODY_18,
              {
                marginBottom: 10,
                color: "#DC2626",
              },
            ]}
          >
            Kaller
          </Text>

          <View
            style={{
              display: "flex",
              height: isMobile ? 117.051 : resultWaiting ? 160 : 170,
              padding: isMobile ? 7.622 : resultWaiting ? 12 : 16,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: isMobile ? 10.162 : resultWaiting ? 8 : 12,
              width: isMobile ? 120 : resultWaiting ? 160 : 200,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#374151",
              backgroundColor: "rgba(31, 41, 55, 0.50)",
            }}
          >
            <View
              style={{
                width: isMobile ? 60 : resultWaiting ? 80 : 110,
                height: isMobile ? 60 : resultWaiting ? 80 : 110,
                overflow: "hidden",
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                variant={
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "player"
                    : "profileMedium"
                }
                src={
                  organizer.profilePicture === ""
                    ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                    : organizer.profilePicture
                }
              />
            </View>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_14
                  : AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white, textAlign: "center" },
              ]}
              numberOfLines={1}
            >
              {organizer.userID || "Unknown"}
            </Text>
          </View>
          {isWinnerSet &&
          eventDetails?.resultStatus?.winner === organizer.userID ? (
            <View style={{}}>
              <CommonButton
                title="Winner"
                textStyle={AppFontStyle.BOLD_ANYBODY_20}
                onTap={() => {}}
                buttonStyle={{
                  paddingVertical:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 0
                      : 12,
                  paddingHorizontal:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 0
                      : 24,
                  backgroundColor: AppColors.appGreenColor_51AF07,
                  borderRadius: 10,
                  shadowOpacity: 0,
                  height: 45,
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
              />
            </View>
          ) : (
            <View style={{ paddingTop: 45 }}></View>
          )}
        </View>

        {/* Game Section */}
        <View
          style={{
            alignItems: "center",
            flex: isMobile ? 0.5 : 0.6,
            justifyContent: "center",
            gap: isMobile ? 6 : 16,
            height: resultWaiting ? (isMobile ? 150 : 170) : undefined,
          }}
        >
          {/* VS Logo - Always visible */}
          <ImageComponent
            url={AppImages.icVsLogo}
            style={{
              width: isMobile ? 40 : 56,
              height: isMobile ? 80 : 126.274,
              resizeMode: "contain",
            }}
          />

          {/* Game Image and Title - Hidden when resultWaiting */}
          {!resultWaiting && (
            <>
              {/* Game Image */}
              <ImageComponent
                url={eventDetails.gameImage || ""}
                style={{
                  height: isMobile ? 58 : 160,
                  width: isMobile ? undefined : 160,
                  alignSelf: isMobile ? "stretch" : "auto",
                  borderRadius: 12,
                  resizeMode: "cover",
                }}
              />

              {/* Game Title */}
              <Text
                style={[
                  isMobile
                    ? AppFontStyle.BOLD_ANYBODY_14
                    : AppFontStyle.BOLD_ANYBODY_18,
                  {
                    textAlign: "center",
                    color: AppColors.white,
                    maxWidth: isMobile ? 120 : 160,
                  },
                ]}
                numberOfLines={2}
              >
                {eventDetails.gameTitle || "Unknown Game"}
              </Text>
            </>
          )}
        </View>

        {/* Challenger Section */}
        <View
          style={{
            flex: 1,
            alignItems: "center",
            gap: isMobile ? 4 : resultWaiting ? 6 : 12,
            height: resultWaiting ? (isMobile ? 150 : 170) : undefined,
          }}
        >
          {/* Opponent Label */}
          <Text
            style={[
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? AppFontStyle.BOLD_ANYBODY_14
                : AppFontStyle.BOLD_ANYBODY_18,
              {
                marginBottom: 10,
                color: "#DC2626",
              },
            ]}
          >
            Opponent
          </Text>

          <View
            style={{
              display: "flex",
              height: isMobile ? 117.051 : resultWaiting ? 160 : 170,
              padding: isMobile ? 7.622 : resultWaiting ? 12 : 16,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: isMobile ? 10.162 : resultWaiting ? 8 : 12,
              width: isMobile ? 120 : resultWaiting ? 160 : 200,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#374151",
              backgroundColor: "rgba(31, 41, 55, 0.50)",
            }}
          >
            <View
              style={{
                width: isMobile ? 60 : resultWaiting ? 80 : 110,
                height: isMobile ? 60 : resultWaiting ? 80 : 110,
                overflow: "hidden",
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <CropImage
              image={
                challenger.profilePicture === ""
                  ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  : challenger.profilePicture
              }
              clipId="clip-upper"
              x={20}
              y={0}
              width={88}
              height={100}
              scale={1.5}
              transform={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "translate(-17, 0)"
                  : "translate(-20, 0)"
              }
            /> */}
              <Avatar
                variant={
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "player"
                    : "profileMedium"
                }
                src={
                  challenger.profilePicture === ""
                    ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                    : challenger.profilePicture
                }
              />
            </View>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_14
                  : AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white, textAlign: "center" },
              ]}
              numberOfLines={1}
            >
              {challenger.userID || "Unknown"}
            </Text>
          </View>
          {isWinnerSet &&
          eventDetails?.resultStatus?.winner === challenger.userID ? (
            <View style={{}}>
              <CommonButton
                title="Winner"
                textStyle={AppFontStyle.BOLD_ANYBODY_20}
                onTap={() => {}}
                buttonStyle={{
                  paddingVertical:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 0
                      : 12,
                  paddingHorizontal:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 0
                      : 24,
                  backgroundColor: AppColors.appGreenColor_51AF07,
                  borderRadius: 10,
                  shadowOpacity: 0,
                  height: 45,
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
              />
            </View>
          ) : (
            <View style={{ paddingTop: 45 }}></View>
          )}
        </View>
      </View>
    </View>
  );
};

export default PlayersView;
